export enum CategoryType {
  TwoWheelers = 'TwoWheelers',
  Trucks = 'Trucks',
  PackersAndMovers = 'PackersAndMovers',
  Courier = 'Courier',
  Partload = 'Partload',
}

export const getStringFromType = (categoryType: CategoryType): string => {
  switch (categoryType) {
    case CategoryType.TwoWheelers:
      return 'Two Wheelers';
    case CategoryType.Trucks:
      return 'Trucks';
    case CategoryType.PackersAndMovers:
      return 'Packers & Movers';
    case CategoryType.Courier:
      return 'Intercity Courier Service';
    case CategoryType.Partload:
      return 'Partload';
  }
};

export const getTypeFromString = (category: string): CategoryType | null => {
  switch (category) {
    case 'Two Wheelers':
      return CategoryType.TwoWheelers;
    case 'Trucks':
      return CategoryType.Trucks;
    case 'Packers & Movers':
      return CategoryType.PackersAndMovers;
    case 'Courier Service':
    case 'Courier Services':
    case 'All India Parcel':
    case 'Intercity Courier Service':
    case 'Courier':
    case 'Intercity':
      return CategoryType.Courier;
    case 'Partload':
      return CategoryType.Partload;
    default:
      return null;
  }
};

export const getTypeFromStringV2 = (category: string): CategoryType => {
  switch (category) {
    case 'two-wheelers':
      return CategoryType.TwoWheelers;
    case 'trucks':
      return CategoryType.Trucks;
    case 'pnm':
      return CategoryType.PackersAndMovers;
    case 'courier':
      return CategoryType.Courier;
    case 'partload':
      return CategoryType.Partload;
    default:
      return CategoryType.Trucks;
  }
};

export const getStringFromTypeV2 = (categoryType: CategoryType): string => {
  switch (categoryType) {
    case CategoryType.TwoWheelers:
      return 'two-wheelers';
    case CategoryType.Trucks:
      return 'trucks';
    case CategoryType.PackersAndMovers:
      return 'pnm';
    case CategoryType.Courier:
      return 'courier';
    case CategoryType.Partload:
      return 'partload';
  }
};
